(function ($) {

	$.textAreaLimited = function (el) {

		var _textarea = this;
		var _internal = {};
		_textarea.settings = {};

		var init = function () {
			_textarea.element = $(el);
			_textarea.settings.limit = _textarea.element.data('textarea-limited');

			_textarea.charsUsed = 0;
			_textarea.charsRemaining = _textarea.settings.limit;
			_textarea.limitExceeded = false;

			_textarea.charsUsedElement = null;
			_textarea.charsRemainingElement = null;

			_internal.addCountElements();
			_internal.bindEvents();
			_internal.updateCharCounts();
		};

		_internal.addCountElements = function() {
			var charCountsElement = $('<div class="textarea-limited-char-counts"></div>').insertAfter(_textarea.element);
			var charsUsedWrapperElement = $('<div> / ' + _textarea.settings.limit + ' characters</div>').appendTo(charCountsElement);

			_textarea.charsUsedElement = $('<span class="textarea-limited-chars-used"></span>').prependTo(charsUsedWrapperElement);
			_textarea.charsRemainingElement = $('<div class="textarea-limited-chars-remaining textarea-limited-char-counts-error"></div>').appendTo(charCountsElement);
		};

		_internal.bindEvents = function () {
			_textarea.element.on('input propertychange', _internal.updateCharCounts);
		};

		_internal.updateCharCounts = function () {
			_textarea.charsUsed = _textarea.element.val()
				// Allow for new lines counting as 2 characters in C#
				.replace(/\r?\n/gi, '**')
				.split('').length;
			_textarea.charsRemaining = _textarea.settings.limit - _textarea.charsUsed;
			_textarea.limitExceeded = _textarea.charsRemaining < 0;

			_internal.updateCharsUsedElement();
			_internal.updateCharsRemainingElement();
		};

		_internal.updateCharsUsedElement = function () {
			_textarea.charsUsedElement.html(_textarea.charsUsed)
				.toggleClass('textarea-limited-char-counts-error', _textarea.limitExceeded);
		};

		_internal.updateCharsRemainingElement = function () {
			_textarea.charsRemainingElement.html(_textarea.limitExceeded ? _textarea.charsRemaining : '');
		};

		init();
	};

})(jQuery);

$(document).ready(function () {
	$('[data-textarea-limited]').each(function () {
		new $.textAreaLimited(this);
	});
});
